
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class PrivateImage extends Vue {
  @Prop({ default: '' }) src!: string;

  private visible = false;

  @Watch('src', { immediate: true })
  onSrcChange() {
    this.visible = false;
  }

  onImageLoad() {
    setTimeout(() => {
      this.visible = true;
    });
  }
}
